import request from "../request";

export const getDIN276CostGroups = () => request.get("/din276-cost-groups");

export const getDIN276CostGroupById = (id) =>
	request.get(`/din276-cost-groups/${id}`);

export const getDIN276Hierarchy = async () =>
	request.get("/din276-cost-groups/hierarchy");

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	getDIN276CostGroups,
	getDIN276CostGroupById,
	getDIN276Hierarchy,
};
